function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _require = require('./transaction-types'),
  formatTransactionTypeName = _require.formatTransactionTypeName;
var REQUEST_TO_MODULE = {
  'chat message': 'Chat',
  'chat history': 'Chat',
  'request blocks': 'Explorer',
  'request block': 'Explorer',
  'request transaction': 'Explorer',
  'request supply': 'Explorer',
  'request address': 'Explorer',
  send: 'Wallet',
  receive: 'Wallet',
  registry: 'Registry',
  'registry lookup': 'Registry',
  register: 'Registry',
  record: 'Registry',
  store: 'Store',
  'store purchase': 'Store',
  purchase: 'Store',
  buy: 'Store',
  sell: 'Store',
  'arcade create': 'Arcade',
  'arcade accept': 'Arcade',
  gamemove: 'Arcade',
  game: 'Arcade',
  relay: 'Relay',
  email: 'Email',
  archive: 'Archive',
  post: 'RedSquare',
  like: 'RedSquare',
  repost: 'RedSquare'
};
function detectTransactionModule(tx) {
  var _tx$type;
  var txType = (_tx$type = tx === null || tx === void 0 ? void 0 : tx.type) !== null && _tx$type !== void 0 ? _tx$type : tx === null || tx === void 0 ? void 0 : tx.transaction_type;
  var typeName = formatTransactionTypeName(txType);
  if (typeName === 'Fee') return 'Fee';
  if (typeName === 'GoldenTicket') return 'GoldenTicket';
  if (typeName === 'ATR') return 'ATR';
  if (typeName === 'Issuance') return 'Issuance';
  if (typeName === 'BlockStake') return 'BlockStake';
  var msg = tx === null || tx === void 0 ? void 0 : tx.msg;
  if (msg && _typeof(msg) === 'object') {
    if (msg.module && typeof msg.module === 'string') {
      return capitalizeFirst(msg.module);
    }
    if (msg.request && typeof msg.request === 'string') {
      var lower = msg.request.toLowerCase();
      if (REQUEST_TO_MODULE[lower]) {
        return REQUEST_TO_MODULE[lower];
      }
    }
  }
  if (typeName !== 'Normal' && typeName !== 'Unknown') {
    return typeName;
  }
  return 'Unknown';
}
function capitalizeFirst(str) {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// Consensus-level transaction categories. These are produced by the protocol
// itself (block fee distribution, golden tickets, ATR rebroadcasts, issuance,
// block staking) rather than an application module, so they are excluded from
// the "Most Popular Modules" ranking.
var NON_MODULE_CATEGORIES = new Set(['Fee', 'GoldenTicket', 'ATR', 'Issuance', 'BlockStake']);

// Canonical Saito Wiki pages for application modules. Entries left as null are
// rendered as plain text until a URL is supplied, so links can be filled in
// later without any UI changes. Do not invent URLs here.
var MODULE_WIKI_URLS = {
  RedSquare: null,
  Twilight: null,
  Arcade: null,
  Registry: null,
  Store: null,
  Chat: null,
  Wallet: null,
  Email: null,
  Relay: null,
  Archive: null,
  Explorer: null
};
function moduleWikiUrl(moduleName) {
  if (!moduleName) {
    return null;
  }
  var url = MODULE_WIKI_URLS[moduleName];
  return typeof url === 'string' && url ? url : null;
}

// Rank application modules by how many of the supplied recent transactions they
// account for. Consensus-level categories are excluded so the ranking reflects
// genuine application activity. Percentages are relative to the module-attributed
// transactions in the sample (a rolling window of recently loaded blocks), so
// they are estimates over that window rather than the whole chain.
function summarizeModulePopularity() {
  var _options$limit;
  var transactions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var limit = (_options$limit = options.limit) !== null && _options$limit !== void 0 ? _options$limit : 6;
  var counts = new Map();
  var total = 0;
  for (var i = 0; i < transactions.length; i++) {
    var name = detectTransactionModule(transactions[i]) || 'Unknown';
    if (NON_MODULE_CATEGORIES.has(name)) {
      continue;
    }
    counts.set(name, (counts.get(name) || 0) + 1);
    total++;
  }
  var rows = Array.from(counts.entries()).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      count = _ref2[1];
    return {
      name: name,
      count: count,
      percent: total > 0 ? Math.round(count / total * 100) : 0,
      wikiUrl: moduleWikiUrl(name)
    };
  }).sort(function (a, b) {
    return b.count - a.count || a.name.localeCompare(b.name);
  });
  return {
    total: total,
    rows: limit ? rows.slice(0, limit) : rows
  };
}
module.exports = {
  detectTransactionModule: detectTransactionModule,
  summarizeModulePopularity: summarizeModulePopularity,
  moduleWikiUrl: moduleWikiUrl,
  MODULE_WIKI_URLS: MODULE_WIKI_URLS,
  NON_MODULE_CATEGORIES: NON_MODULE_CATEGORIES
};